// extracted by css-extract-rspack-plugin
export default {"RulesetActionMenuLinkItem":"RulesetActionMenu-module__RulesetActionMenuLinkItem__L_oKqL8"};